'use strict';
import * as $j_com$002eraquo$002eew$002e$002dJs$002dArray$0024 from "./com.raquo.ew.-Js-Array$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_util_JsPriorityQueue(getRank) {
  this.yW = null;
  this.iC = null;
  this.yW = getRank;
  this.iC = $j_com$002eraquo$002eew$002e$002dJs$002dArray$0024.$m_Lcom_raquo_ew_JsArray$().db($j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().r0(new $j_java$002elang$002e$002dObject.$ac_O([])));
}
export { $c_Lcom_raquo_airstream_util_JsPriorityQueue as $c_Lcom_raquo_airstream_util_JsPriorityQueue };
$p = $c_Lcom_raquo_airstream_util_JsPriorityQueue.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_util_JsPriorityQueue;
/** @constructor */
function $h_Lcom_raquo_airstream_util_JsPriorityQueue() {
}
export { $h_Lcom_raquo_airstream_util_JsPriorityQueue as $h_Lcom_raquo_airstream_util_JsPriorityQueue };
$h_Lcom_raquo_airstream_util_JsPriorityQueue.prototype = $p;
$p.TL = (function(item) {
  var itemRank = (this.yW.j(item) | 0);
  var insertAtIndex = 0;
  var foundHigherRank = false;
  while (((insertAtIndex < (this.iC.length | 0)) && (!foundHigherRank))) {
    if (((this.yW.j(this.iC[insertAtIndex]) | 0) > itemRank)) {
      foundHigherRank = true;
    } else {
      insertAtIndex = ((1 + insertAtIndex) | 0);
    }
  }
  this.iC.splice(insertAtIndex, 0, item);
});
$p.ae = (function(item) {
  return ((this.iC.indexOf(item) | 0) !== (-1));
});
var $d_Lcom_raquo_airstream_util_JsPriorityQueue = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_util_JsPriorityQueue, "com.raquo.airstream.util.JsPriorityQueue", ({
  hp: 1
}));
export { $d_Lcom_raquo_airstream_util_JsPriorityQueue as $d_Lcom_raquo_airstream_util_JsPriorityQueue };
